module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "sitecontent"
  }, [_c('div', {
    staticClass: "contact_banner"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row cont"
  }, [_c('h1', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t专注提供云打印解决方案与服务")]), _vm._v(" "), _c('p', {
    staticClass: "wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_vm._v("\n\t\t\t\t\t\t为客户提供可靠、持续的服务，让每个创造价值")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "npagePage contact"
  }, [_c('div', {
    staticClass: "intro_cont"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('div', {
    staticClass: "intro_tab-content tab-content"
  }, [_c('div', {
    staticClass: "tab-pane_na"
  }, [_c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("联系我们")])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact_cont wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "col-xs-4 bri"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact_icon1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("公司地址")]), _vm._v(" "), _c('p', [_vm._v("广州市天河区珠村大粒沙路38号4栋")])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-4 bri"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact_icon2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("公司电话")]), _vm._v(" "), _c('p', [_vm._v("13600093009")])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-4"
  }, [_c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/contact_icon3.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h5"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:server@zonelink.cc"
    }
  }, [_vm._v("server@zonelink.cc")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row contact_cont2"
  }, [_c('ul', [_c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("销售经理")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v("梁经理\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("15017026610\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信号：")]), _vm._v("wxid_q9y4xtv1a25d21\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:sell@zonelink.cc"
    }
  }, [_vm._v("sell@zonelink.cc")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("售后客服")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v("胡先生\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("13696988194\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信号：")]), _vm._v("hutuyang_2005\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:service@zonelink.cc"
    }
  }, [_vm._v("service@zonelink.cc")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("市场合作")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系人：")]), _vm._v("马先生\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("18688777685\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信号：")]), _vm._v("maliang_311\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:market@zonelink.cc"
    }
  }, [_vm._v("market@zonelink.cc")])])]), _vm._v(" "), _c('li', {
    staticClass: "col-xs-3 wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('h4', [_vm._v("技术支持")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("联系：")]), _vm._v("蔡先生\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("电话：")]), _vm._v("18138794144")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("微信：")]), _vm._v("WDM-18138794144\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("邮箱：")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:tech@zonelink.cc"
    }
  }, [_vm._v("tech@zonelink.cc")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix row"
  }, [_c('h3', {
    staticClass: "header_title"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("公司简介")])])]), _vm._v(" "), _c('div', {
    staticClass: "row about_cont wow fadeInUp animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInUp"
    }
  }, [_c('div', {
    staticClass: "about_cont"
  }, [_c('p', [_vm._v("众联云是一家创新型技术性公司，为企业提供云打印解决方案相关产品的研发和服务，拥有强大的技术研发团队和全面的综合服务体系。")]), _vm._v(" "), _c('p', [_vm._v("众联云管理平台由广州众联云技术有限公司开发，本公司是一家专注物联网解决方案的高新科技公司，我们在万物互联的时代趋势推动下，紧跟潮流，运用最新科技成果，研发各类处于行业领先水平的智能终端，致力于满足客户的多样化需求，降低经营成本，提高生产效率。通过众联云数据处理中心的数据聚合能力，结合稳定高效的4G/5G通讯技术，实现24小时全天候不漏单智能打印，无需手机，无需电脑，无需人工参与。众联云打印机支持多店铺绑定，来单真人语音提醒，催单提醒，退款申请提醒，个性化定制小票等功能，感谢您的支持和使用。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("多年来，众联云致力于整合企业云打印服务，秉承“创新、求实、诚信、拼搏”的企业精神，为各行业商家提供全方位的打印研发、帮助餐饮商家自动接收，自动打印平台订单，提高了商家处理订单的效率，真正实现应用智能化，提升商家在网络经济市场的竞争力。以客户为中心，以技术为基础，以质量求生存，以诚信求发展，专业、专注为客户提供一个立体化的云打印解决方案。\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-598e385b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/downloadContent.vue
// module id = 338
// module chunks = 1